import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=4b65b2ac&"
import script from "./CommentsView.vue?vue&type=script&lang=js&"
export * from "./CommentsView.vue?vue&type=script&lang=js&"
import style0 from "./CommentsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b65b2ac')) {
      api.createRecord('4b65b2ac', component.options)
    } else {
      api.reload('4b65b2ac', component.options)
    }
    module.hot.accept("./CommentsView.vue?vue&type=template&id=4b65b2ac&", function () {
      api.rerender('4b65b2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/CommentsView.vue"
export default component.exports